import React, { Component } from 'react';

import ChartHelper from '../Helper/ChartHelper';

export default class LongitudinalDataDisplay extends Component {

    constructor(props) {
        super(props);

        this.chartHelper = new ChartHelper();

        this.state = {
            dataPoints: 7,
            sumMode: this.props.sumMode,
            isCustom: false,
            datePickerActive: false,
            customYear: null,
            customMonth: null,
            customDay: null
        }

        this.organizedDateObj = null;
        this.monthMap = {
            "01": { short: "JAN", long: "January" }, "02": { short: "FEB", long: "February" },
            "03": { short: "MAR", long: "March" }, "04": { short: "APR", long: "April" },
            "05": { short: "MAY", long: "May" }, "06": { short: "JUN", long: "June" },
            "07": { short: "JUL", long: "July" }, "08": { short: "AUG", long: "August" },
            "09": { short: "SEP", long: "September" }, "10": { short: "OCT", long: "October" },
            "11": { short: "NOV", long: "November" }, "12": { short: "DEC", long: "December" }
        }

        this.setDataPoints = this.setDataPoints.bind(this);
        this.setCustomDataPoints = this.setCustomDataPoints.bind(this);
        this.setSumMode = this.setSumMode.bind(this);

        this.launchDatePicker = this.launchDatePicker.bind(this);
        this.cancelDatePicker = this.cancelDatePicker.bind(this);
        this.organizeDateItems = this.organizeDateItems.bind(this);
        this.selectDateYearMonth = this.selectDateYearMonth.bind(this);
        this.selectDateDay = this.selectDateDay.bind(this);
        this.countCustomDays = this.countCustomDays.bind(this);

        this.transformDataForChart = this.transformDataForChart.bind(this);

        this.generateDatePicker = this.generateDatePicker.bind(this);
    }

    setDataPoints(points) {
        if (this.state.dataPoints != points || this.state.isCustom) {
            this.setState({ dataPoints: points, isCustom: false });
        }
    }

    setCustomDataPoints() {
        let points = this.countCustomDays();

        this.setState({ isCustom: true, dataPoints: points, datePickerActive: false });
    }

    setSumMode(isSumMode) {
        if (this.state.sumMode != isSumMode) {
            this.setState({ sumMode: isSumMode });
        }
    }

    launchDatePicker() {
        if (!this.state.datePickerActive) {
            this.organizeDateItems();
            this.setState({ datePickerActive: true })
        }
    }

    cancelDatePicker() {
        if (this.state.datePickerActive) {
            this.setState({ datePickerActive: false })
        }
    }

    organizeDateItems() {
        let organizedDateObj = this.props.data.reduce((r, e) => {

            let year = e.dateString.substring(6, 10);
            let month = e.dateString.substring(0, 2);
            let day = e.dateString.substring(3, 5);

            if (!r[year]) {
                r[year] = {};
            }
            if (!r[year][month]) {
                r[year][month] = []
            }
            if (!r[year][month].includes(day)) {
                r[year][month].push(day);
            }

            return r;
        }, {});

        this.organizedDateObj = organizedDateObj;
    }

    selectDateYearMonth(year, month) {
        this.setState({
            customYear: year,
            customMonth: month,
            customDay: null
        });
    }

    selectDateDay(day) {
        this.setState({
            customDay: day
        })
    }

    countCustomDays() {
        if (this.state.customYear === null || this.state.customMonth === null || this.state.customDay === null) {
            return 0;
        }

        let customDateString = this.state.customMonth + "/" + this.state.customDay + "/" + this.state.customYear;
        let dayCounter = 0;
        for (var i = this.props.data.length - 1; i >= 0; i--) {
            dayCounter++;
            if (this.props.data[i].dateString === customDateString) {
                break;
            }
        }

        return dayCounter;
    }

    transformDataForChart() {
        let data = this.props.data.slice(Math.max(this.props.data.length - this.state.dataPoints, 1));

        let cyData = [];
        let lyData = [];

        let cyValue = 0;
        let lyValue = 0;
        data.forEach(x => {
            let dateVal = new Date(x.dateString);

            if (this.state.sumMode) {
                cyValue += x.cyValue;
                lyValue += x.lyValue;
            } else {
                cyValue = x.cyValue;
                lyValue = x.lyValue;
            }

            cyData.push({
                name: "cy",
                value: [([dateVal.getFullYear(), dateVal.getMonth() + 1, dateVal.getDate()].join('/')), cyValue]
            });
            lyData.push({
                name: "ly",
                value: [([dateVal.getFullYear(), dateVal.getMonth() + 1, dateVal.getDate()].join('/')), lyValue]
            });
        });

        return [cyData, lyData];
    }

    generateDatePicker() {
        if (this.organizedDateObj === null) {
            return null;
        }

        let result = [];
        let dateObj = this.organizedDateObj;

        if (this.state.customYear === null || this.state.customMonth === null) {

            _.sortBy(Object.keys(dateObj), y => y).forEach(year => {
                result.push((
                    <div className={"year"}>{year}</div>
                ));

                _.sortBy(Object.keys(dateObj[year]), m => m).forEach(month => {
                    result.push((
                        <div className={"month"} onClick={this.selectDateYearMonth.bind(null, year, month)}>{this.monthMap[month].short}</div>
                    ));
                });
            });
        } else if (this.state.customDay === null) {
            result.push((
                <div className={"year"} onClick={this.selectDateYearMonth.bind(null, null, null)}>{this.monthMap[this.state.customMonth].long + " " + this.state.customYear}</div>
            ));

            _.sortBy(dateObj[this.state.customYear][this.state.customMonth], d => d).forEach(day => {
                result.push((
                    <div className={"day"} onClick={this.selectDateDay.bind(null, day)}>{day}</div>
                ));
            });
        } else {

            let lastDateString = this.props.data[this.props.data.length - 1].dateString;

            let lYear = lastDateString.substring(6, 10);
            let lMonth = lastDateString.substring(0, 2);
            let lDay = lastDateString.substring(3, 5);

            result.push((
                <div className={"results-container"}>
                    <div className={"normal"}>{"Analyze from"}</div>
                    <div className={"date"} onClick={this.selectDateYearMonth.bind(null, null, null)}>{this.monthMap[this.state.customMonth].long + " " + this.state.customDay + ", " + this.state.customYear}</div>
                    <div className={"normal"}>{"through"}</div>
                    <div className={"date"}>{this.monthMap[lMonth].long + " " + lDay + ", " + lYear}</div>
                    <div className={"day-count"}>{this.countCustomDays() + " Days"}</div>
                </div>
            ));
        }

        return result;
    }

    render() {

        let prefix = "";
        let suffix = "";
        if (this.props.dataIdentity.type === "MNY") {
            prefix = "$";
        } else if (this.props.dataIdentity.type === "PCT") {
            suffix = "%";
        }


        let chartJsx = this.chartHelper.generateDateLineChart(this.transformDataForChart(), prefix, suffix);

        let datePickerJsx = this.generateDatePicker();

        return (
            <div className={"longitude-blast-outer"}>
                <div className={"header"}>{this.props.kpiName}</div>
                <div className={"sub-header"}>{this.props.dataSpecifier}</div>
                <div className={"options-container stack-1 extended"}>
                    <div className={"option" + (this.state.sumMode ? "" : " active") + (this.props.isAvg ? " wide" : "")} onClick={this.setSumMode.bind(null, false)}>{"Daily"}</div>
                    {this.props.isAvg ? null :
                        (<div className={"option" + (this.state.sumMode ? " active" : "")} onClick={this.setSumMode.bind(null, true)}>{"Total"}</div>)
                    }
                </div>
                <div className={"data-info-container"}>
                    {chartJsx}
                </div>
                <div className={"options-container stack-4"}>
                    <div className={"option" + (!this.state.isCustom && this.state.dataPoints === 7 ? " active" : "")} onClick={this.setDataPoints.bind(null, 7)}>{"7 Days"}</div>
                    <div className={"option" + (!this.state.isCustom && this.state.dataPoints === 30 ? " active" : "")} onClick={this.setDataPoints.bind(null, 30)}>{"30 Days"}</div>
                    <div className={"option" + (!this.state.isCustom && this.state.dataPoints === 60 ? " active" : "")} onClick={this.setDataPoints.bind(null, 60)}>{"60 Days"}</div>
                    <div className={"option" + (!this.state.isCustom && this.state.dataPoints === 90 ? " active" : "")} onClick={this.setDataPoints.bind(null, 90)}>{"90 Days"}</div>
                    <div className={"option" + (!this.state.isCustom && this.state.dataPoints === 180 ? " active" : "")} onClick={this.setDataPoints.bind(null, 180)}>{"180 Days"}</div>
                    <div className={"option" + (!this.state.isCustom && this.state.dataPoints === 365 ? " active" : "")} onClick={this.setDataPoints.bind(null, 365)}>{"365 Days"}</div>
                    <div className={"option wide " + (this.state.isCustom ? " active" : "")} onClick={this.launchDatePicker}>{"Custom" + (this.state.isCustom ? " " + this.state.dataPoints + " Days" : "")}</div>
                </div>
                <div className={"longitude-date-picker" + (!this.state.datePickerActive ? " hidden" : "")}>
                    <div className={"date-picker-header"}>{"Custom Date"}</div>
                    <div className={"date-picker-container"}>{datePickerJsx}</div>
                    <div className={"date-picker-nav"}>
                        <div className={"button cancel"} onClick={this.cancelDatePicker}>{"Cancel"}</div>
                        <div className={"button accept" +
                            (this.state.customYear === null || this.state.customMonth === null || this.state.customDay === null ?
                                " inactive" : "")} onClick={this.setCustomDataPoints}>{"Accept"}</div>
                    </div>
                </div>
            </div>
        );
    }
}
